import { put, select, takeLatest } from 'redux-saga/effects'
import { IOption } from '../../../common/common.types'
import Logger from '../../../services/logger.service'
import { getApiErrorHandlerSelector } from '../selectors'
import {
  setButtons,
  setCallback,
  setErrorMessage,
  setHeader,
  showAlert,
  showToast,
} from '../store/apiErrorHandler.actions'
import { ApiErrorHandlerConstants } from '../store/apiErrorHandler.constants'
import { IApiErrorHandlerState } from '../store/apiErrorHandler.types'

export function* handleApiError() {
  try {
    const apiErrorHandler: IApiErrorHandlerState = yield select(getApiErrorHandlerSelector)
    const { error } = apiErrorHandler
    if (error && error.messages?.length) {
      const index = error.messages.findIndex((x) => x.status === error.status)
      const isAlert = error.messages[index].display.some((e: IOption) => e.name === 'Alert')
      let errorMessage = ''
      if (error.status === null && error.messages[index].message.includes('TypeError: Failed to fetch')) {
        errorMessage = `${error.messages[index].message}: The error may be due to a client - server version mismatch. Please update the app to the latest version.`
      } else {
        errorMessage = `${error.messages[index].message}`
        if (!isAlert) errorMessage = `${errorMessage} Status: ${error.messages[index].status}`
      }

      yield put(setErrorMessage(errorMessage))

      if (error.callback) {
        yield put(setCallback(error.callback))
      }

      if (error.messages[index].display.some((e: IOption) => e.name === 'Toastr')) {
        yield put(showToast(true))
      }
      if (isAlert) {
        if (error.messages[index].buttons) yield put(setButtons(error.messages[index].buttons))
        if (error.messages[index].alertHeader) yield put(setHeader(error.messages[index].alertHeader))
        yield put(showAlert(true))
      }
      if (error.messages[index].display.some((e: IOption) => e.name === 'Log')) {
        const stackTrace = error.messages[index].error ? `Stack Trace: ${error.messages[index].error?.stackTrace}` : ''
        Logger.error(`API Error: ${errorMessage} ${stackTrace}`)
        console.log(`API Error: ${errorMessage} ${stackTrace}`)
      }
    } else {
      const errorMessage = `Status: ${error?.status} No error messages sent back from the server.`
      Logger.error(`API Error: ${errorMessage}`)
      console.log(`API Error: ${errorMessage}`)
    }
  } catch (e: any) {
    const cause = e.message ? e.message : 'unknown'
    Logger.error(`An error occurred during handleApiErrorSaga. Cause: ${cause}`)
  }
}
export function* handleApiErrorSaga() {
  yield takeLatest([ApiErrorHandlerConstants.HANDLE_API_ERROR], handleApiError)
}
